import { render, staticRenderFns } from "./de-tdb.vue?vue&type=template&id=74285b83"
import script from "./de-tdb.vue?vue&type=script&lang=js"
export * from "./de-tdb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports